import { ApiError } from '../../lib/api';

export function ErrorBanner({ error }: { error: unknown }) {
  if (!error) return null;
  const msg = error instanceof Error ? error.message : 'Unbekannter Fehler';
  const code = error instanceof ApiError ? error.code : null;
  return (
    <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
      {code && <span className="font-mono text-xs text-red-500 mr-2">{code}</span>}
      {msg}
    </div>
  );
}
